export default "__VITE_ASSET__CQkkfbp8__"